import styled from 'styled-components'
import LangSwitcher from './LangSwitcher'
import OrgSwitcher from './OrgSwitcher'
import HeaderSidebarToggle from './HeaderSidebarToggle'
import HeaderTitle from './HeaderTitle'
import HeaderEditToggle from './HeaderEditToggle'
import ThemeToggle from './ThemeToggle'
import AppSwitcherToggle from './AppSwitcherToggle'

const HeaderWrapper = styled.header`
  display: flex;
  justify-content: space-between;
  padding: 1rem;
  height: 4rem;
`

const TitleWrapper = styled.div`
  display: flex;
  min-width: 0;
`

const SettingsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`

function Header() {

  return (
    <HeaderWrapper id='HeaderWrapper'>
      <TitleWrapper>
        <HeaderSidebarToggle />
        <HeaderTitle />
        <HeaderEditToggle />
      </TitleWrapper>
      <SettingsWrapper name='SettingsWrapper'>
        <AppSwitcherToggle />
        <ThemeToggle />
        <OrgSwitcher />
        <LangSwitcher />
      </SettingsWrapper>
    </HeaderWrapper>
  )
}

export default Header